import { components, InputProps } from 'react-select';
import { getOnPaste } from './getOnPaste';
import { BaseOption, SelectProps } from './types';

export const MultiSelectInput = (props: InputProps<BaseOption>) => {
  const { selectProps, options, getValue } = props;
  // @ts-ignore
  const { canCreate, canBulkPaste, optionLimit, pasteDelimiter: delimiter, onChange } = selectProps;
  const value = getValue();
  const onPaste = canBulkPaste
    ? getOnPaste({
        options: options as SelectProps['options'],
        canCreate,
        optionLimit,
        delimiter,
        onChange,
        value,
      })
    : undefined;

  return <components.Input {...props} aria-controls="multiselect-input" onPaste={onPaste} />;
};
